/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator
 *
 */
Intesa.DatePickerAppointment = function() {
    var datepicker = this;

    this.init = function() {
        console.log('Component -> DatePickerAppointment');

        datepicker.changeElementToArab();

        $('strong.pop1__value__strong.translate_arab').text(function(i, v) {
            return datepicker.changeToArab(v.split(''));
        });

        if ($('.translate_arab').length > 0) {
            $("table").keypress(function() {
                datepicker.changeElementToArab();
            });
        }
        if ($('.translate_arab').length > 0) {
            $("table").keydown(function() {
                datepicker.changeElementToArab();
            });
        }
        if ($('.translate_arab').length > 0) {
            $('.pull-right,.pull-left').on('click', function() {
                datepicker.changeElementToArab();
            })
        }
    }

    this.changeElementToArab = function() {
// non compatibile con nuovo sviluppo xdcr-1809
//        $('.translate_arab').find('.day.selectable,.day.unselectable,.empty,.datepicker-month').text(function(i, v) {
//            return datepicker.changeToArab(v.split(''));
//        });
        
        $('.translate_arab').find('.day.selectable,.day.unselectable,.empty,.datepicker-month').each(function(i, v) {
        	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
        	console.log("change number to arab ");
        	if($(v)[0] != undefined){
	        	for(var cou = 0; cou < $(v)[0].childNodes.length; cou ++){
	        		var chars = $(v)[0].childNodes[cou].textContent.split('');
		            for (var i = 0; i < chars.length; i++) {
		                if (parseFloat(chars[i]) > -1) {
		                	chars[i] = arabicNumbers[chars[i]];
		                }
		            }
		            $(v)[0].childNodes[cou].textContent = chars.join('');
	        	}
        	}
        });
        
        $('.translate_arab').find('.day.selectable,.day.unselectable,.empty').each(function() {
            var self = this;
            var title = $(self).attr('title');
            if (title) $(self).attr('title', datepicker.changeToArab(title.split('')));
        })

      }

    this.changeToArab = function(chars) {
    	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
        for (var i = 0; i < chars.length; i++) {
            if (parseFloat(chars[i]) > -1) {
                chars[i] = arabicNumbers[chars[i]];
            }
        }
        return chars.join('');
    }
};

/**
 * Get class instance
 *
 */
Intesa.DatePickerAppointment.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.date_picker_appointment) {

        window.intesa.date_picker_appointment = new Intesa.DatePickerAppointment();

    }

    return window.intesa.date_picker_appointment;

};